/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Membership_Quota_Monthly_Credit_OtherInputs */

const fr_membership_quota_monthly_credit_other = /** @type {(inputs: Membership_Quota_Monthly_Credit_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cours / mois (Crossfit ou Hyrox)`)
};

/**

* @param {Membership_Quota_Monthly_Credit_OtherInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_quota_monthly_credit_other = /** @type {((inputs: Membership_Quota_Monthly_Credit_OtherInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Quota_Monthly_Credit_OtherInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_quota_monthly_credit_other(inputs)
});